import React from 'react';

const SeparatorBlock = ({ block }) => {
  return (
    <div className="separator-block">
      <hr />
    </div>
  );
};

export default SeparatorBlock;
